import { MixSwapShippingProgress, Maybe } from 'ggApp/types/graphql';
import { shippingProgressVar } from '../../clientFactory/variables';

const SwapTypePolicy = {
    type: 'Swap',
    policy: {
        fields: {
            shippingProgress: {
                read(): Maybe<MixSwapShippingProgress> {
                    return shippingProgressVar();
                },
            },
        },
    },
};

export default SwapTypePolicy;
